import { render, staticRenderFns } from "./DistrictContainer.vue?vue&type=template&id=1242ec0d&"
import script from "./DistrictContainer.vue?vue&type=script&lang=js&"
export * from "./DistrictContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports